import { Observable, of } from 'rxjs';
import { inject } from '@angular/core';
import { NotificationsAlertsService } from '@notifications/infra';
import { CoordinatesModel, Log, Logger } from '@core';

export class UpdateAlertsLocationCommandHandler {
  private readonly notificationsAlertsService: NotificationsAlertsService = inject(NotificationsAlertsService);
  protected readonly logger: Logger = inject(Logger);

  setLocation(coordinates: CoordinatesModel | null): Observable<void> {
    if (!coordinates) {
      this.logger.log(Log.Log, { message: 'Coordinates not found.' });
      return of(void 0);
    }

    return this.notificationsAlertsService.setLocation(coordinates);
  }
}
